import { ReactNode } from 'react';

export const isEmptyNode = (node: ReactNode): boolean =>
  node === null ||
  node === undefined ||
  node === '' ||
  (Array.isArray(node) && node.length === 0);
